
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import jQuery from 'jquery'

import configureStore,  { getStore } from './State/store.js'

import SearchController from './ComponentsAir/SearchController.js'

import { deactivateAllFilters } from './State/actions.js'
import { selectActiveFilters } from './State/selectors.js'

export var modalWrap = null

Foundation.SearchInterface = class SearchInterface {
  static mount (mountPoint, dataFromEV) {
    var store = configureStore(dataFromEV)

    ReactDOM.render(
      <Provider store={store}>
        <SearchController />
      </Provider>,
      mountPoint
    )
  }

  static bindClear (clearEl) {
    jQuery(clearEl).on("click", () => {
      var store = getStore()
      store.dispatch(deactivateAllFilters())
    })
    jQuery(document).ready( () => {
      var store = getStore()
      store.subscribe( () => {
        var state = store.getState()
        var activeFilters = selectActiveFilters(state)
        var showClear = activeFilters.length ? true : false
        if (showClear) {
          clearEl.classList.remove("uk-hidden")
        } 
        else {
          clearEl.classList.add("uk-hidden")
        }
      })
    })
  }


  /* xxx may be more elegant way to go about this goal */
  static createModalWrap (target, classname) {
    jQuery(target).append(jQuery("<div>").addClass(classname))

    // note this is scoped to the module and exported
    modalWrap = jQuery(`.${classname}`)[0]
  }
}


window.Foundation.SearchInterface = Foundation.SearchInterface

/* xxx this is all to match exisitng usage, consider changes */
window.Foundation.Page = {}
window.Foundation.Page.SearchController = {}
window.Foundation.Page.SearchController.register_callback = Foundation.SearchInterface.register_callback
